import { useContext } from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import GlobalContext from "../../../contexts/store";
import { postCalculatePriceAPI } from "../grade/grade.service";


export function useCalculatePrice(optionType) {
  const { state: { selectedOptions } } = useContext(GlobalContext)
  const {
    data: calcPrices
  } = useQuery(['calc', selectedOptions],
               () => postCalculatePriceAPI(
                 {
                   ...selectedOptions
                 }),
               {
                 refetchOnWindowFocus: false,
                 enabled: !!selectedOptions?.modelType && !!selectedOptions[optionType]
               })
  return {
    data: {
      calcPrices
    }
  }
}

export const pageSteps = {
  device: '기기 선택',
  grade: '등급 선택',
  period: '기간 선택',
  insurance: '보험 선택',
  option: '추가 옵션',
  order: '결제하기',
}

export const allSteps = [
  { modelType: 'S9', steps: ['device', 'period', 'insurance', 'option', 'order'] },
  { modelType: 'PCX', steps: ['device', 'grade', 'period', 'insurance', 'order'] },
  { modelType: 'NIU', steps: ['device', 'period', 'insurance', 'option', 'order'] },
]

export function useStepControl(now) {
  const navigate = useNavigate()
  const { state: { selectedDevice } } = useContext(GlobalContext)

  const nowIndex = selectedDevice?.steps.indexOf(now);
  const prev = selectedDevice?.steps[nowIndex - 1] && selectedDevice?.steps[nowIndex - 1]
  const next = selectedDevice?.steps[nowIndex + 1] && selectedDevice?.steps[nowIndex + 1]

  function move(destination) {
    if (destination === 'device') return navigate('/')
    navigate(`/${selectedDevice.modelType}/${destination}`)
  }

  return {
    prev: { value: prev, text: pageSteps[prev] },
    next: next && { value: next, text: pageSteps[next] },
    now: { value: now, text: pageSteps[now] },
    move
  }
}